import {
  getWorkInfo,
  getQuestionList,
  getQuestionInfo,
  submitWork,
} from "@saas/server-api/src/homework/index";
import { Message, MessageBox } from "element-ui";

const state = {
  workId: "",
  activeIndex: 0,
  workInfo: {},
  questionList: [],
  questionInfo: {}, //当前题目信息
};

const mutations = {
  setWorkId: (state, id) => {
    state.workId = Number(id);
  },
  setActiveIndex: (state, index) => {
    state.activeIndex = index;
  },
  setWorkInfo: (state, obj) => {
    state.workInfo = obj || {};
  },
  setQuestionList: (state, arr) => {
    state.questionList = arr || {};
  },
  setQuestionInfo: (state, obj) => {
    state.questionInfo = obj || {};
  },
};

const actions = {
  apiGetWorkInfo({ commit, state }, id) {
    commit("setWorkId", id);
    // 初始化数据
    commit("setActiveIndex", 0);
    commit("setWorkInfo", {});
    commit("setQuestionInfo", {});
    let params = {
      work_id: state.workId,
    };
    getWorkInfo(params).then((res) => {
      if (res.code === 1) {
        commit("setWorkInfo", res.data);
      }
      // else {
      //   Message({
      //     message: res.message,
      //     type: "error",
      //   });
      // }
    });
  },
  apiGetQuestionList({ commit, state, dispatch, getters }, id) {
    commit("setWorkId", id);
    commit("setQuestionList", []);
    let params = {
      work_id: state.workId,
    };
    getQuestionList(params).then((res) => {
      if (res.code === 1) {
        commit("setQuestionList", res.data);
        if (res.data && res.data.length) {
          dispatch("apiGetQuestionInfo", {
            work_id: state.workId,
            question_ids: getters.questionId,
          });
        }
      } else {
        Message({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  apiGetQuestionInfo({ commit, state, getters }, params) {
    getQuestionInfo(params).then((res) => {
      if (res.code === 1) {
        if (res.data && res.data[0]) {
          let info = res.data[0];
          if (info.child && info.child.length) {
            let subInfo = info.child[getters.subIndex];
            console.log(subInfo, "subInfo", getters.subIndex);
            subInfo.big_question_type = info.question_type;
            if (info.question_type !== 5) {
              subInfo.subContent = subInfo.content;
            }
            subInfo.content = info.content;
            subInfo.difficulty = info.difficulty;
            commit("setQuestionInfo", subInfo);
          } else {
            info.big_question_type = info.question_type;
            commit("setQuestionInfo", info);
          }
        }

        // let data = res.data[0];
        // let { child, question_type } = data;
        // // 大题-问题类型
        // data.big_question_type = question_type;
        // if (child && child.length) {
        //   // 复合题
        //   data.subContent = child[state.subIndex]?.content || "";
        //   data.option = child[state.subIndex]?.option || [];
        //   data.question_type = child[state.subIndex]?.question_type || "";
        //   data.subQuestionId = child[state.subIndex]?.id || "";
        // } else {
        //   commit("setQuestionInfo", data);
        // }
      } else {
        Message({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  changeQuestionIndex({ commit, state, dispatch, getters }, index) {
    commit("setActiveIndex", index);
    dispatch("apiGetQuestionInfo", {
      work_id: state.workId,
      question_ids: getters.questionId,
    });
  },
  submitAnswer({ dispatch }) {
    MessageBox.confirm(
      "确认提交作业吗？提交后无法变更。<br/>作业批改后可看到相应批改结果。",
      "提示",
      {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
      }
    )
      .then(() => {
        dispatch("apiSubmitWork");
      })
      .catch(() => {});
  },
  apiSubmitWork({ state }) {
    submitWork({
      work_id: state.workId,
    }).then((res) => {
      if (res.code === 1) {
        Message({
          message: "提交成功",
          type: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        Message({
          message: res.message,
          type: "error",
        });
      }
    });
  },
};

const getters = {
  questionId: (state) => {
    let item = state.questionList[state.activeIndex] || {};
    if (item.question_pid) {
      return item.question_pid;
    } else {
      return item.question_id;
    }
  }, //当前题目id
  subIndex: (state) => {
    return state.questionList[state.activeIndex]?.sub_index || 0;
  },
  questionIndexArr: ({ questionList }) => {
    let arr = [];
    for (let i = 0; i < questionList.length; i++) {
      if (i === 0) {
        arr.push(1);
      } else {
        let item = questionList[i];
        let preItem = questionList[i - 1];
        if (item.question_pid) {
          if (item.question_pid === preItem.question_pid) {
            arr.push(arr[arr.length - 1]);
          } else {
            arr.push(arr[arr.length - 1] + 1);
          }
        } else {
          arr.push(arr[arr.length - 1] + 1);
        }
      }
    }
    return arr;
  },
  canSubmit: ({ workInfo }) => {
    let now = new Date().getTime();
    if (workInfo?.work_end_time && workInfo.work_end_time * 1000 < now) {
      // 超时
      return false;
    }
    if (workInfo.status > 1) {
      // 已提交
      return false;
    } else {
      return true;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
